<template>
  <section ref="section" class="-login-header deepDive">
    <Observer name="fade-up" @enter="enter" @leave="leave" @enter.once="callGTM('eePromoView')">
      <div class="wrapper h-100">
        <div class="row h-100 justify-content-md-end">
          <div class="col-12 title-section">
            <h2 v-if="item.headerTitle" v-text="HCi18n ? $t(item.headerTitle) : item.headerTitle"></h2>
            <div v-if="user" class="title-section__user">
              <template v-if="user.prefix">{{ $t(prefixMap[user.prefix]) }}</template>
              <template v-if="user.firstname">{{ user.firstname }}</template>
              <template v-if="user.lastname">{{ user.lastname }}</template>
            </div>
          </div>
          <div class="col-12 text-content col-md-4 align-content-end text-center">
            <div aria-hidden="true" class="-wysiwyg font-btn pb-4" v-if="item.text" v-html="$t(item.text)"></div>
            <template v-if="item.ctaText">
              <router-link
                v-if="!item.ctaLink.includes('http')"
                :to="localizedUrl + item.ctaLink"
                class="btn -large -white font-btn"
                v-text="HCi18n ? $t(item.ctaText) : item.ctaText"
              ></router-link>
              <a v-else :href="item.ctaLink" target="blank" class="btn -large -white font-btn" v-text="HCi18n ? $t(item.ctaText) : item.ctaText"></a>
            </template>
          </div>
        </div>
      </div>
    </Observer>
    <button v-if="item.type === 'video'" type="button" class="btn-autoPlay" :class="{ '-paused': pauseVideo }" :aria-label="pauseVideo ? 'Play' : 'Pause'" @click="toggleVideo"></button>
  </section>
</template>

<script>
import { Parallax } from 'leaps/dist/leaps'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { ReadyHook } from 'vue-asyncready'
import ImageManager from 'vue-storefront-prismic-ssr/utilities/ImageManager'
import { getRouteName } from '../utilities'

export default {
  props: ['item', 'items', 'HCi18n', 'pagePosition', 'siblings-components', 'user'],
  mixins: [ReadyHook],
  name: 'deep_dive',
  data() {
    return {
      pauseVideo: false,
      appeared: false,
      prefixMap: {
        mr: 'Mr.',
        mrs: 'Ms.'
      }
    }
  },
  components: {
    Parallax,
  },
  computed: {
    localizedUrl() {
      return currentStoreView().url || ''
    },
    imageUrl() {
      return this.item.image.url
    },
    imageLowDefinition() {
      return ImageManager.getLowDefinition(this.imageUrl, 400, 0.5636523266)
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (process.browser) {
        const Splitting = require('splitting')
        Splitting()
      }
    })
  },
  methods: {
    enter() {
      if (!this.appeared) {
        this.$refs.section.classList.remove('-visibility-auto')
        this.$refs.parallax.updateConfig()
        this.$refs.parallax.update()
        this.appeared = true
        if (this.$refs.video) {
          this.$refs.source.setAttribute('src', this.$refs.source.dataset.src)
          this.$refs.source.removeAttribute('data-src')
          setTimeout(() => {
            this.$refs.video.load()
          }, 200)
        } else {
          if (this.$refs.picture) this.$refs.picture.srcset = ImageManager.getSrcSet(this.imageUrl, 1800, 200, 100, 0.5636523266)
        }
      } else if (this.$refs.video && this.$refs.video.paused) this.$refs.video.play()
    },
    leave() {
      if (this.$refs.video && !this.$refs.video.paused) this.$refs.video.pause()
    },
    toggleVideo() {
      if (this.pauseVideo) {
        this.$refs.video.play()
      } else {
        this.$refs.video.pause()
      }
      this.pauseVideo = !this.pauseVideo
    },
    callGTM(event, link) {
      if (getRouteName(this.$route.name) === 'home') {
        let data = {
          event: event,
          promotions: [
            {
              creative: 'section',
              id: 'sectionDeepDive_' + this.pagePosition,
              name: this.HCi18n ? this.$t(this.item.title) : this.item.title,
              position: 1,
            },
          ],
        }
        if (link) {
          data.nextPageVisited = link
        }
        this.$gtm.trackEvent(data)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

section {
  position: relative;
  padding-top: 4rem;
  padding-bottom: 2rem;
  color: var(--zenith-white);
  background-image: linear-gradient(170deg, #023497 0%, #011131 100%);

  .title-section {
    &__user {
      font-size: 1.4rem;
      font-weight: 300;
    }
  }

  @include bp(max md) {
    .title-section {
      text-align: center;
    }

    min-height: calc(100vw / 1.33);
  }

  .wrapper {
    padding: 0 4rem;
  }

  & > div {
    width: 100%;
    height: 30rem;
  }

  *:not(video) {
    position: relative;
    z-index: 20;
  }

  .obs-fade-up {
    transform: translateY(0);
    .btn {
      transform: translateY(4rem);
      opacity: 0;
    }
    .h2 {
      /deep/ .char {
        opacity: 0;
        transform: translateY(-6rem);
      }
    }
    .main-text {
      /deep/ .char {
        opacity: 0;
        transform: translateY(8rem);
      }
    }
  }

  .h2 {
    margin-bottom: 1rem;

    /deep/ .word {
      overflow: hidden;
      display: inline-block;
    }
    /deep/ .char {
      display: inline-block;
      transform: translateY(0);
      @include appearTitle(200ms);
    }
  }

  .main-text {
    text-transform: uppercase;

    /deep/ .word {
      /*overflow: hidden;*/
      display: inline-block;
      vertical-align: top;
    }
    /deep/ .char {
      display: inline-block;
      vertical-align: top;
      transform: translateY(0);
      @include appearTitle(300ms);
    }

    @include bp(max md) {
      margin-bottom: 4rem;
    }
  }

  .btn {
    @include appear(600ms);
  }

  &.-white {
    .h2,
    .main-text {
      color: var(--zenith-component-title);
    }
  }

  video,
  img {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    // height:100%;
    height: calc(100% + 11rem);
    object-fit: cover;
    pointer-events: none;
    max-width: 100%;
    backface-visibility: hidden;
    // transform: translateZ(0) scale(1, 1);
    // filter: #{"grayscale(none)"} brightness(none);
    // @include appearImg(100ms);
  }
  .btn-autoPlay {
    position: absolute;
  }

  .row.h-100 {
    gap: 4.5rem;
  }

  .h-100 {
    height: 100%;
  }
}
</style>
